var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 52,
    height: 52,
    fill: "#2f354b",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 32 62.2 4.2c.7-.7.7-1.8 0-2.5s-1.8-.7-2.5 0L32 29.5 4.2 1.8c-.7-.7-1.8-.7-2.5 0s-.7 1.8 0 2.5L29.5 32 1.8 59.8c-.7.7-.7 1.8 0 2.5.3.3.8.5 1.2.5s.9-.2 1.2-.5L32 34.5l27.7 27.8c.3.3.8.5 1.2.5s.9-.2 1.2-.5c.7-.7.7-1.8 0-2.5z"
  })));
};
export default SvgClose;